<template>
    <div class="rsv_search_form" v-show="isShow">
        <input type="text" class="input_s input_search" ref="input" :placeholder="$t('reservationwindow.searchresults.input_search_placeholder')" v-model="keyword" @keydown.enter="action_Search">
        <div class="input_loading" v-if="isSimpleLoading"></div>
        <button class="btn btn_s btn_white" @click="action_Search">{{$t('reservationwindow.searchresults.button_search_title')}}</button>
    </div>
</template>


<script>
import { useQueryClient } from '@tanstack/vue-query'
import { hserviceFindSimpleQueryOptions } from '@/composables/queries/hservice/use-hservice-find-simple-query'
import { isApiErrorWithCode } from '@/apis/instances/check-api-response'

export default {
    setup() {
        const queryClient = useQueryClient()
        return { queryClient }
    },
    props: {
        isShow: Boolean
    },
    data() {
        return {
            keyword: undefined,
            isSimpleLoading: false
        }
    },
    watch: {
        keyword: function(newValue) {
            if (newValue == '' || newValue == undefined) {
                this.$emit('setSearchResults', undefined)
            }
            this.$emit('setSearchKeyword', this.keyword)
        }
    },
    methods: {
        async action_Search() {
            if (this.keyword == undefined || this.keyword == '') { return }
            // Loading Start
            this.isSimpleLoading = true

            let hospitalID = this.hospital.selectedHospital._id
            let model = {
                hospitalID: hospitalID,
                keyword: this.keyword,
                skip: 0,
                limit: 1000,
                isTest: {$ne : true}
            }
            let searchResults
            try {
                searchResults = await this.queryClient.fetchQuery(hserviceFindSimpleQueryOptions(model))
            } catch (err) {
                // 기존 동작 미러링: 봉투 code != 0 이면 로그만 남기고 중단
                if (!isApiErrorWithCode(err)) throw err
                this.isSimpleLoading = false
                console.log(err)
                return
            }
            this.isSimpleLoading = false

            this.$emit('setSearchResults', searchResults)
        },

        clearKeyword() {
            this.keyword = ''
        }
    }
}
</script>